import { Affiliate } from 'models/Integrations';

export const DYNAMIC_PRICING_TOOLS = {
  [Affiliate.BEYONDPRICING]: {
    name: 'BeyondPricing',
    url: 'https://www.beyondpricing.com/',
  },
  [Affiliate.DPGO]: {
    name: 'DPGO',
    url: 'https://www.dpgo.com/',
  },
  [Affiliate.NIGHTPRICER]: {
    name: 'Nightpricer',
    url: 'https://nightpricer.com/home',
  },
  [Affiliate.PRICELABS]: {
    name: 'PriceLabs',
    url: 'https://pricelabs.co/',
  },
  [Affiliate.QUIBBLE]: {
    name: 'Quibble',
    url: 'https://quibblerm.com/',
  },
  [Affiliate.TURBOSUITE]: {
    name: 'Turbosuite',
    url: 'http://www.turbosuite.com/',
  },
  [Affiliate.WHEELHOUSE]: {
    name: 'Wheelhouse',
    url: 'https://www.usewheelhouse.com/',
  },
};

export const DYNAMIC_PRICING_TOOLS_PRIORITY_ORDER = [
  Affiliate.PRICELABS,
  Affiliate.WHEELHOUSE,
  Affiliate.BEYONDPRICING,
  Affiliate.DPGO,
  Affiliate.NIGHTPRICER,
  Affiliate.TURBOSUITE,
  Affiliate.QUIBBLE,
];
